/**
 * This decorator allows a method to be executed only once
 */
export function CallOnce() {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;
        let hasBeenCalled = false;

        descriptor.value = function (...args: any[]) {
            if (hasBeenCalled) return;

            hasBeenCalled = true;
            return originalMethod.apply(this, args);
        };

        return descriptor;
    };
}
